import { useEffect } from "react";
import { useStore } from "../../../app/data/root.store";
import { VaultPendingFilesModal } from "../VaultPendingFilesModal/VaultPendingFilesModal";
import { DeepAnalysisReviewResultModal } from "../DeepAnalysisReviewResultModal/DeepAnalysisReviewResultModal";
import { observer } from "mobx-react";
import { ContinueDeepAnalysisResultModal } from "../ContinueDeepAnalysisResultModal/ContinueDeepAnalysisResultModal";
import { ManualAnalysisPendingResultModal } from "../ManualAnalysisPendingResultModal/ManualAnalysisPendingResultModal";
import { DeepAnalysisFailModal } from "../DeepAnalysisFailModal/DeepAnalysisFailModal";

export const VaultModals = observer(({ onFlowStepChange, onFailed, createItemsState = false }) => {
    const { vaultStore, userStore, uiStore: { isDesktopView } } = useStore();

    useEffect(() => {
        const fetchVaultsFormStep = async () => await vaultStore.fetchVaultsFormStep();

        if (isDesktopView) {
            fetchVaultsFormStep();
        } else {
            vaultStore.setVaultFormStep(null);
        }
    }, [vaultStore, isDesktopView]);

    const isWelcome = userStore.isWelcome;
    const onCloseDoneModal = () => {
        vaultStore.setVaultFormStep(null);
        if (isWelcome) {
            onFlowStepChange(1);
        } else {
            vaultStore.resetAndRefetchFiles();
        }
    };


    return (
        <>
            {vaultStore.vaultFormStep === 'Pending' && <VaultPendingFilesModal createItemsState={createItemsState} />}
            {vaultStore.vaultFormStep === 'Pre-Process' && <DeepAnalysisReviewResultModal />}
            {vaultStore.vaultFormStep === 'Done' && <ContinueDeepAnalysisResultModal onClose={onCloseDoneModal} />}
            {vaultStore.vaultFormStep === 'deep-analysis' && <ManualAnalysisPendingResultModal onClose={onCloseDoneModal} />}
            {vaultStore.vaultFormStep === 'fail' && <DeepAnalysisFailModal onCloseModal={onFailed} />}
        </>
    );
});